import { render, staticRenderFns } from "./query-case-turn-record.vue?vue&type=template&id=6dc9d66f"
import script from "./query-case-turn-record.vue?vue&type=script&lang=ts"
export * from "./query-case-turn-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports